import jsPDF from 'jspdf';

// jsPDF's built-in "helvetica" is one of the PDF standard-14 fonts and is NOT
// embedded in the file. The viewer/printer must supply it, and some Windows
// machines (seen with Microsoft Edge) substitute a symbol font such as
// Wingdings, which turns every report into gibberish.
//
// Fix: embed Liberation Sans (metric-compatible with Helvetica/Arial, so
// layouts do not shift) and register it under the "helvetica" name. Every
// existing doc.setFont('helvetica', ...) call and jspdf-autotable then use the
// embedded font automatically.

const FONT_FILES: Record<string, string> = {
  normal: 'LiberationSans-Regular.ttf',
  bold: 'LiberationSans-Bold.ttf',
  italic: 'LiberationSans-Italic.ttf',
  bolditalic: 'LiberationSans-BoldItalic.ttf',
};

const loadedFonts: Record<string, string> = {};

const toBinaryString = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer);
  let result = '';
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    result += String.fromCharCode.apply(null, Array.from(bytes.subarray(i, i + chunk)));
  }
  return result;
};

export const pdfFontsReady: Promise<void> = Promise.all(
  Object.entries(FONT_FILES).map(async ([style, file]) => {
    const response = await fetch(`${process.env.PUBLIC_URL}/fonts/${file}`);
    if (!response.ok) throw new Error(`Failed to load PDF font ${file}`);
    loadedFonts[style] = toBinaryString(await response.arrayBuffer());
  })
)
  .then(() => undefined)
  .catch((error) => {
    console.error('PDF font embedding unavailable, falling back to standard fonts:', error);
  });

(jsPDF.API as any).events.push([
  'initialized',
  function (this: jsPDF) {
    if (Object.keys(loadedFonts).length !== Object.keys(FONT_FILES).length) return;

    Object.entries(FONT_FILES).forEach(([style, file]) => {
      this.addFileToVFS(file, loadedFonts[style]);
      this.addFont(file, 'helvetica', style);
    });
    // The initial active font is the standard (non-embedded) Helvetica, so switch to the embedded one.
    this.setFont('helvetica', 'normal');
  },
]);
